import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type ShoreTeamsRequest = CommonTableRequest;

export interface ShoreTeam {
    id: number;
    name: string | null;
    shoreDepartmentId: number | null;
    shoreDepartmentName: string | null;
    email: string | null;
    phone: string | null;
    entityLocationId: number | null;
    entityLocationName: string | null;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface ShoreTeamsResponse {
    data: ShoreTeam[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateShoreTeamRequest {
    name: string;
    shoreDepartmentId: number;
    email: string;
    phone: string;
    entityLocationId: number;
}

export type UpdateShoreTeamRequest = CreateShoreTeamRequest;

export const getApiShoreTeams = (
    clientId: number,
    tenantAlias: string,
    payload: ShoreTeamsRequest,
): Promise<ShoreTeamsResponse> =>
    httpApi
        .post<ShoreTeamsResponse>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-teams/search`, payload)
        .then(({ data }) => data);

export const createApiShoreTeam = (
    clientId: number,
    tenantAlias: string,
    payload: CreateShoreTeamRequest,
): Promise<ShoreTeam> =>
    httpApi
        .post<ShoreTeam>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-teams`, payload)
        .then(({ data }) => data);

export const updateApiShoreTeam = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateShoreTeamRequest,
): Promise<ShoreTeam> =>
    httpApi
        .put<ShoreTeam>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-teams/${id}`, payload)
        .then(({ data }) => data);

export const deleteApiShoreTeam = (clientId: number, tenantAlias: string, id: number): Promise<ShoreTeam> =>
    httpApi
        .delete<ShoreTeam>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-teams/${id}`)
        .then(({ data }) => data);
